module.exports = __webpack_public_path__ + "static/media/ve.37f8a279.svg";